import { render } from "./proposition-defeated-badge.vue?vue&type=template&id=38209872&scoped=true"
import script from "./proposition-defeated-badge.vue?vue&type=script&lang=js"
export * from "./proposition-defeated-badge.vue?vue&type=script&lang=js"

import "./proposition-defeated-badge.vue?vue&type=style&index=0&id=38209872&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38209872"]])

export default __exports__